class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  onFormSubmit(event) {
    const rawValue = this.input.value.trim();
    if (!rawValue) return;

    if (rawValue.includes('title:') || rawValue.includes('vendor:')) return;

    let hiddenInput = this.querySelector('input[type="hidden"][name="q"]');
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'q';
      this.input.form.appendChild(hiddenInput);
    }

    const words = rawValue.split(/\s+/).filter((w) => w.length > 0);
    const formattedQuery = words
      .map((word) => {
        const cleanWord = word.replace(/[*()]/g, '');
        return `(title:${cleanWord}* OR vendor:${cleanWord}* OR tag:${cleanWord}* OR product_type:${cleanWord}* OR sku:${cleanWord}*)`;
      })
      .join(' AND ');

    hiddenInput.value = formattedQuery;
    this.input.removeAttribute('name');
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
